import { useQuery } from '@apollo/client';

import type { TopCompaniesQueryVariables } from '../../graphql/queries/top-companies.gql-types';
import { TopCompaniesDocument } from '../../graphql/queries/top-companies.gql-types';

export const useTopCompanies = ({
  limit,
  offset,
}: TopCompaniesQueryVariables) => {
  const variables = {
    limit,
    offset,
  };

  const response = useQuery(TopCompaniesDocument, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return response;
};
